import { useMutation, useQuery } from "@tanstack/react-query";
import { getSales, importSales } from "../api/sales";
import { AxiosRequestConfig } from "axios";
import { ApiResponse, PaginatedApiResponse, PaginationInfo } from "@/types/api";
import { Sale } from "@/types/sale";
import { queryClient } from "@/api/queryClient";
import { extractErrorMessage } from "@/utils/api";
import { message } from "antd";

export const useGetSales = (config?: AxiosRequestConfig) => {
  return useQuery<
    PaginatedApiResponse<Sale[]>,
    Error,
    { data: Sale[]; pagination: PaginationInfo }
  >({
    queryKey: ["sales", config?.params],
    queryFn: () => getSales(config),
    select: (response) => ({
      data: response.data,
      pagination: response.pagination,
    }),
  });
};

export const useGetSalesOptions = (config?: AxiosRequestConfig) => {
  return useQuery<ApiResponse<Sale[]>, Error, Sale[]>({
    queryKey: ["sales-options", config?.params],
    queryFn: () => getSales(config),
    select: (response) => response.data,
  });
};

export const useImportSales = (options: {
  onSuccess?: (data: ApiResponse<Sale[]>) => void;
}) => {
  return useMutation<ApiResponse<Sale[]>, Error, File>({
    mutationFn: importSales,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["sales"] });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      const errorMessage = extractErrorMessage(error);
      message.error(errorMessage);
    },
  });
};
